import React from 'react';

const InspectorCard = React.createClass({

	getInitialState: function() {
		return {
			open: this.props.open,
      disabled: this.props.disabled,
      buttonSelected: false
		}
	},

	render: function() {
		let classNames = `abl-inspector-card ${this.props.className || ''}`;
		
    if(this.state.open) {
      classNames += ' abl-open'; 
    }

    return (
    	<div className={classNames}>
	      <div className="abl-menubar" onClick={this.handleClick}>
	      	<div className="abl-menubar-label">{this.props.header}</div>
          <div className="abl-menubar-icon">
          </div>
	      </div>
        <div className="abl-card-body">
	       <div className="abl-card-content">{this.props.children}</div>
        </div>
      </div>
    );
  },

  handleButtonSelect: function(id, element, data, selected) {
    if(!this.state.disabled) {
      this.setState({buttonSelected: selected});
      if(this.props.onMenubarButtonSelect) {
        this.props.onMenubarButtonSelect(id, element, data, selected);
      }
    }
  },

  handleClick: function() {
    if(!this.state.disabled) {
      this.setState({open: !this.state.open});
    }
  }

});

export default InspectorCard;


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule_inspector/inspector_card.js
 **/